import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseSystemCharts } from '@/api/responses/systemCharts'

export namespace SystemChartsApi {
  /**
   * 知識マップ系統図一覧取得
   *
   * @param subjectCode 教科コード
   * @returns 系統図一覧
   */
  export async function getSystemCharts(subjectCode: string): Promise<ApiResponseSystemCharts> {
    const params = {
      subjectCode: subjectCode,
    }
    return await ApiBase.get('/systemCharts', params)
  }
}
